import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "20",
  viewBox: "0 0 10 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("filter", { id: "a" }, [
        _createElementVNode("feColorMatrix", {
          in: "SourceGraphic",
          values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        })
      ])
    ], -1),
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      filter: "url(#a)",
      transform: "translate(-7 -2)"
    }, [
      _createElementVNode("path", {
        fill: "#1A1A1A",
        d: "M15.174 5.32H17V2.14A24 24 0 0 0 14.34 2c-2.632 0-4.435 1.656-4.435 4.7v2.8H7v3.555h2.905V22h3.56v-8.945h2.789l.443-3.555h-3.231V7.05c0-1.027.276-1.73 1.708-1.73"
      })
    ], -1)
  ]))]))
}
export default { render: render }